"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_app__store(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ef012a72-dafb-4b9f-a357-3f0cad79454b",
    "data-name": "ICON",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("title", null, "apps"), /*#__PURE__*/React.createElement("path", {
    id: "5ee1934c-e686-4b77-902f-defedf2b6afd",
    "data-name": "<Path>",
    d: "M81.31,144H50.68a5.49,5.49,0,0,1-4.88-2.53,5.33,5.33,0,0,1,.12-5.45l15.35-29a5.12,5.12,0,0,1,9.3,0l15.51,29a5.33,5.33,0,0,1,.12,5.45A5.5,5.5,0,0,1,81.31,144Z",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "8f3e5372-9fb5-4fc6-af24-d995ed1f0c1c",
    "data-name": "<Path>",
    d: "M66,84A18,18,0,1,1,84,66,18,18,0,0,1,66,84Z",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "125.91 104.09 145.86 120.06 137.88 144 113.94 144 105.95 120.06 125.91 104.09",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.91,
    y: 48,
    width: 36,
    height: 36,
    rx: 8,
    ry: 8,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 28,
    width: 136,
    height: 136,
    rx: 12,
    ry: 12,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var _default = ic_app__store;
exports.default = _default;